/* Temporary recovery for Hulk's null display_setting incident, 13 October 2026.
   Saved merchant display settings only; eligible offers, prices and checkout remain Hulk-owned. */
(function (w, d) {
  'use strict';
  var savedDisplay = {"apply_discountcode_condition":"after","atc_button_setting":"","body_bg_color":"#ffffff","body_font_size":"14","body_text_color":"#000000","border_color":"#cccccc","bulk_fomo_msg":"Buy {{ quantity }} more and get {{ bulk_discount }} discount","bulk_qty_pro_text_msg":"Buy {{ quantity }} for {{ amount }}","button_color":"#0A344F","button_text_color":"#FFFFFF","cart_discount_away_msg":"Buy {{ quantity }} more to get {{ discount }}","cart_discount_msg":"Congratulations! You saved {{ amount }} by buying in bulk!","cart_discount_reminder_msg":"Spent {{ amount }} more to get {{ discount }} discount","cart_min_price":"Minimum Price","cdam_font_size":"14","cdam_text_color":"#e28902","cdm_bg_color":"#e3efe1","cdm_font_size":"16","cdm_text_color":"#0c7300","cum_bg_color":"#FFECE0","cum_font_size":"16","cum_text_color":"#000000","custom_css":".discount_code_box .hulkapps_discount_hide{\njustify-content: center;\n}\nbody.product .offer-options-list [type=radio]+label:after,body.product .offer-options-list [type=radio]+label:before {\nborder: 1px solid #519CB7;\nborder-radius: 12px;\n}\nbody.product .offer-options-list:has(> .offer-option-item:nth-child(5):last-child)\n  .offer-option-item:last-of-type {\n    grid-column: span 2;\n}\nbody.product .offer-option-btn {\ngrid-column: span 2;\n}\nbody.product .offer-options-list [type=radio]:checked+label:after {\n    background-color: #519CB7;\n    opacity: 1;\n}\nbody.product .offer-options-list [type=radio]:checked+label .offer-option_txt,body.product .offer-options-list [type=radio]:checked+label .offer-option_price {\ncolor: #fff;\n}\nbody.product .offer-options-list [type=radio]:checked+label .option-radio {\n    border: 2px solid #fff;\n}\n.offer-options-list [type=radio]:checked+label div.option-radio:after {\nbackground: unset;\nbackground-image: url('https://cdn.shopify.com/s/files/1/0638/9288/1645/files/Vector.png?v=1763028799');\nbackground-size: contain;\nbackground-repeat: no-repeat;\n    width: 20px;\n    height: 20px;\n}\n@media (min-width:1024px) {\nbody.product .hulkapps-volume-discount-tiers {\ndisplay: grid;\ngrid-template-columns: repeat(2,1fr);\ngap: 10px;\n}\n}","custom_js":"(function () {\n  var tierSelector = '.hulkapps-volume-discount-tiers .offer-option-item';\n  var priceSelector =\n    '[id^=\"MainProduct-\"] [id^=\"price-\"] .price-item, ' +\n    '[id^=\"MainProduct-\"] .product-pricing .price__current .money';\n\n  function copyTierPrice(tier) {\n    var source = tier && tier.querySelector('.offer-option .money');\n    if (!source) return;\n\n    var price = source.textContent.trim();\n    document.querySelectorAll(priceSelector).forEach(function (target) {\n      target.textContent = price;\n    });\n  }\n\n  function copySelectedTierPrice() {\n    var selected = document.querySelector(tierSelector + ' [type=\"radio\"]:checked');\n    copyTierPrice(selected && selected.closest(tierSelector));\n  }\n\n  window.setTimeout(copySelectedTierPrice, 500);\n\n  if (window.__polypouchHulkTierPriceBound) return;\n  window.__polypouchHulkTierPriceBound = true;\n\n  document.addEventListener('click', function (event) {\n    var tier = event.target.closest(tierSelector);\n    if (!tier) return;\n    window.setTimeout(function () {\n      copyTierPrice(tier);\n    }, 0);\n  });\n})();\n","customize_message":"Customization Cost for","discount_text":"Discount","discount_text_color":"#fd0000","dynamic_checkout_button_integration":false,"dynamic_checkout_discount_code":false,"enable_atc_setting":true,"enable_cart_discount_message":false,"enable_cart_discount_reminder_msg":false,"enable_discount_code_box":true,"enable_metafield_integration":true,"enable_payment_setting":false,"enable_reminder_msg":true,"facebook_pixel":"","free_field":"Free","get_at_text":"Each","google_analaytics_pixel":"","grid_border_width":"1","grid_preview_layout":"1","header_bg_color":"#eeeeee","header_font_size":"16","header_text_color":"#000000","hide_cart_offer_name_key":false,"hide_offer_product_key":false,"hide_offer_shopify_discount_msg":false,"hide_offer_unique_key":false,"include_decimal_in_offer_table":true,"is_monthly_email":false,"is_option_discount":false,"is_theme_inherit":false,"list_after_quantity":"for","list_before_quantity_cart":"Spend","list_border_color":"#444444","list_button_text":"Add to cart","list_card_radius":"6.0","list_preview_layout":"7","list_total":"Total","max_qty_text":"Maximum Qty","min_qty_after_text":"+","min_qty_before_text":"Buy","min_qty_text":"Minimum Qty","off_text":"Off","offer_help_text":"#fd0000","order_tag":"","pinterest_pixel":"","popular_offer_setting":"","right_left_padding":"15","schedule_store_time":false,"snapchat_pixel":"","table_radius":"0","theme_button_class":"button button--full-width","theme_buy_button_class":"button button--full-width button--secondary","top_bottom_padding":"8"};
  var attempts = 0;
  function install() {
    if (!w.hulkapps || w.hulkapps.store_id !== 'polypouch.myshopify.com') return;
    var original = w.eligible_offer;
    if (typeof original !== 'function') {
      if (++attempts < 400) w.setTimeout(install, 50);
      return;
    }
    if (original.__ppDisplayRecovery) return;
    function recovered(payload) {
      if (payload && payload.eligible_offer && payload.display_setting == null) {
        payload.display_setting = Object.assign({}, savedDisplay);
        d.querySelectorAll('.hulkapps-volumes').forEach(function (root) {
          root.setAttribute('data-pp-display-recovery', 'saved-settings');
        });
      } else {
        d.querySelectorAll('.hulkapps-volumes').forEach(function (root) {
          root.removeAttribute('data-pp-display-recovery');
        });
      }
      return original.apply(this, arguments);
    }
    recovered.__ppDisplayRecovery = true;
    w.eligible_offer = recovered;
  }
  install();
})(window, document);

(() => {
  const selector = '.card-wrapper .price-item';
  const originalMarkup = new Map(
    [...document.querySelectorAll(selector)].map((price) => [price, price.innerHTML])
  );
  let authority = null;
  let unsubscribe = null;

  const restore = () => {
    originalMarkup.forEach((markup, price) => {
      if (price.isConnected && price.innerHTML !== markup) price.innerHTML = markup;
    });
  };

  const scheduleRestore = () => requestAnimationFrame(restore);
  const bindAuthority = () => {
    const nextAuthority = window.PolyPouchPurchasingAuthority;
    if (!nextAuthority || nextAuthority === authority) return;
    unsubscribe?.();
    authority = nextAuthority;
    unsubscribe = authority.subscribe(scheduleRestore);
  };
  const handlePageHide = () => {
    unsubscribe?.();
    unsubscribe = null;
    authority = null;
  };

  document.addEventListener('polypouch:purchasing-authority-ready', bindAuthority);
  window.addEventListener('pagehide', handlePageHide, { once: true });
  bindAuthority();
})();

(() => {
  const processedFirstTiers = new WeakSet();
  let selectionScheduled = false;

  const hideUndiscountedComparisonPrices = (firstTier) => {
    const toggleMatchingComparison = (currentSelector, comparisonSelector) => {
      const currentPrice = firstTier.querySelector(currentSelector);
      const comparisonPrice = firstTier.querySelector(comparisonSelector);
      if (!comparisonPrice) return;

      const currentText = currentPrice?.textContent.trim().replace(/\s+/g, '');
      const comparisonText = comparisonPrice.textContent.trim().replace(/\s+/g, '');
      comparisonPrice.hidden = Boolean(currentText && comparisonText && currentText === comparisonText);
    };

    toggleMatchingComparison('.item-regular_price .money', '.item-compare_price');
    toggleMatchingComparison('.total-regular_price .money', '.total-compare_price');
  };

  const selectLowestTier = () => {
    selectionScheduled = false;

    document.querySelectorAll('.hulkapps-volume-discount-tiers').forEach((tierGroup) => {
      const firstTier = tierGroup.querySelector('.offer-option-item:first-of-type');
      const firstRadio = firstTier?.querySelector('input[type="radio"][name="card_group"]');
      if (!firstRadio) return;

      hideUndiscountedComparisonPrices(firstTier);
      if (processedFirstTiers.has(firstRadio)) return;

      processedFirstTiers.add(firstRadio);
      tierGroup.dataset.lowestTierDefault = firstRadio.value;
      if (firstRadio.checked) return;

      const firstLabel = firstTier.querySelector(`label[for="${CSS.escape(firstRadio.id)}"]`);
      (firstLabel || firstRadio).click();
    });
  };

  const scheduleLowestTierSelection = () => {
    if (selectionScheduled) return;
    selectionScheduled = true;
    requestAnimationFrame(selectLowestTier);
  };

  const tierObserver = new MutationObserver(scheduleLowestTierSelection);
  tierObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pagehide', () => tierObserver.disconnect(), { once: true });
  scheduleLowestTierSelection();
})();
